// extracted by mini-css-extract-plugin
export default {"container":"Style_container__9jJiw"};